import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Link, LinkProps } from "shared/ui/link/Link"

interface HeaderLogoProps extends LinkProps {
  isWhite?: boolean
}

export const HeaderLogo = React.memo(
  ({ isWhite, ...props }: HeaderLogoProps) => {
    const { t } = useTranslation()
    return (
      <Link
        {...props}
        className={classNames("logo", "header__logo", {
          "logo-white": isWhite
        })}
        data-testid="logo"
      >
        <span className="visually-hidden">{t("Link.ToHomepage")}</span>
      </Link>
    )
  }
)
